const isZendeskChatDebugEnabled = (): boolean =>
  process.env.NODE_ENV === 'development'
  || process.env.GATSBY_ZENDESK_CHAT_DEBUG === 'true';
export const logZendeskChat = (
  message: string,
  context?: Record<string, unknown>,
): void => {
  if (!isZendeskChatDebugEnabled()) {
    return;
  }

  if (context) {
    console.info(`[zendesk-chat] ${message}`, context);
    return;
  }

  console.info(`[zendesk-chat] ${message}`);
};
